var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandPayTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "translation-46",
    transform: "translate(-1367 -3984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167072",
    "data-name": "Group 167072",
    transform: "translate(1347 3751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83154",
    "data-name": "Path 83154",
    d: "M23,0C40.851,0,46,5.149,46,23S40.851,46,23,46,0,40.851,0,23,5.149,0,23,0Z",
    transform: "translate(20 233)",
    fill: "#ffe532"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-right",
    transform: "translate(1381 3999.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_45",
    "data-name": "Line 45",
    d: "M12.442.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H12.442a.75.75,0,0,1,.75.75A.75.75,0,0,1,12.442.75Z",
    transform: "translate(2.5 4.25)",
    fill: "#1c2023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_69",
    "data-name": "Line 69",
    d: "M14.942.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H14.942a.75.75,0,0,1,.75.75A.75.75,0,0,1,14.942.75Z",
    transform: "translate(0 9.735)",
    fill: "#1c2023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5450",
    "data-name": "Path 5450",
    d: "M12,19.856a.75.75,0,0,1-.53-1.28l6.522-6.522L11.47,5.53A.75.75,0,0,1,12.53,4.47l7.053,7.053a.75.75,0,0,1,0,1.061L12.53,19.636A.748.748,0,0,1,12,19.856Z",
    transform: "translate(-1.053 -5)",
    fill: "#1c2023"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandPayTransferIcon);
export default __webpack_public_path__ + "static/media/brandPayTransfer_icon.d7663d99de8874bd7e51b83f165ab321.svg";
export { ForwardRef as ReactComponent };